if (!customElements.get('cart-drawer-recommendations')) {
  customElements.define(
    'cart-drawer-recommendations',
    class CartDrawerRecommendations extends HTMLElement {
      static recommendationsCache = new Map();

      recommendationsRequest = undefined;

      connectedCallback() {
        this.loadRecommendations(this.dataset.productId);
      }

      loadRecommendations(productId) {
        if (this.recommendationsRequest) return this.recommendationsRequest;

        const cacheKey = this.getRecommendationsCacheKey(productId);
        const cachedRecommendations = CartDrawerRecommendations.recommendationsCache.get(cacheKey);

        if (cachedRecommendations !== undefined) {
          this.renderRecommendations(cachedRecommendations);
          return Promise.resolve(cachedRecommendations);
        }

        this.recommendationsRequest = fetch(
          `${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`,
        )
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('cart-drawer-recommendations');

            if (recommendations) {
              CartDrawerRecommendations.recommendationsCache.set(cacheKey, recommendations.innerHTML);
              this.renderRecommendations(recommendations.innerHTML);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.recommendationsRequest = undefined;
          });

        return this.recommendationsRequest;
      }

      getRecommendationsCacheKey(productId) {
        return [this.dataset.url, productId, this.dataset.sectionId, this.dataset.cacheKey || ''].join('|');
      }

      renderRecommendations(recommendationsHTML) {
        this.innerHTML = recommendationsHTML.trim().length ? recommendationsHTML : '';
        this.removeCartProductsFromRecommendations();
        this.classList.toggle('cart-drawer__recommendations--loading', !this.innerHTML.trim().length);

        if (this.querySelector('.cart-drawer-recommendation-card')) {
          this.classList.add('product-recommendations--loaded');
        }
      }

      removeCartProductsFromRecommendations() {
        if (!this.dataset.cartProductIds) return;

        const cartProductIds = new Set(this.dataset.cartProductIds.split(',').filter(Boolean));
        this.querySelectorAll('.cart-drawer-recommendation-card[data-product-id]').forEach((card) => {
          if (cartProductIds.has(card.dataset.productId)) card.remove();
        });

        if (!this.querySelector('.cart-drawer-recommendation-card')) {
          this.innerHTML = '';
        }
      }
    },
  );
}
